interface IRecords {
	id: string;
	fields: {
		sales_price: number;
		title_insurance_rate: number;
	};
}

export const titleRateLookup = (
	records: Array<IRecords>,
	salesPrice: number
) => {
	const roundedPrice = Math.round(salesPrice / 1000) * 1000;
	const lookup = records.filter(
		(record) => record.fields.sales_price === roundedPrice
	);
	if(lookup.length === 0) {
		return 0;
	} else {
		return lookup[0]?.fields.title_insurance_rate;
	}


};
